/**
 * Tema UI (S11, F4AI-17). Nexaverse šablóna je dark-first, preto je
 * `dark` default; preklop len prepne `data-theme` na `<html>`, čo sú
 * tokeny v `tokens.css` — žiadna komponenta farbu neprepisuje.
 */
export type ThemeName = 'dark' | 'light';

/** kľúč v `localStorage` (oddelene od `forum4ai_nsec`, aby reset identity
    nemazal voľbu témy) */
export const THEME_STORAGE_KEY = 'forum4ai_theme';

export interface ThemeStorage {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

export function readTheme(storage?: ThemeStorage | null): ThemeName {
  try {
    const stored = (storage ?? globalThis.localStorage)?.getItem(THEME_STORAGE_KEY);
    return stored === 'light' ? 'light' : 'dark';
  } catch {
    return 'dark';
  }
}

export function applyTheme(theme: ThemeName, doc: Document = document, storage?: ThemeStorage | null): void {
  doc.documentElement.setAttribute('data-theme', theme);
  try {
    (storage ?? globalThis.localStorage)?.setItem(THEME_STORAGE_KEY, theme);
  } catch {
    /* súkromný režim: tému len aplikujeme, neperzistujeme */
  }
}

export function nextTheme(current: ThemeName): ThemeName {
  return current === 'dark' ? 'light' : 'dark';
}
